import "core-js/modules/es.array.push.js";
import router from '@/router';
import { defineComponent, ref } from 'vue';
//import { ArrowDown,ArrowUp } from '@element-plus/icons-vue'
import { useI18n } from 'vue-i18n';
export default defineComponent({
  name: 'MobileHeader',
  props: {
    data: Array
  },
  setup(props) {
    const {
      locale
    } = useI18n();
    let enUS = true;
    const showMenu = ref(false);
    const showSubMenu = ref(false);
    //当前子菜单索引
    const subMenuIndex = ref(-1);
    const changeLanguage = () => {
      enUS = !enUS;
      if (enUS) {
        locale.value = 'en-US';
      } else {
        locale.value = 'zh-CN';
      }
    };
    const onClick = i => {
      showMenu.value = false;
      //console.log(props.data[i])
      //路由跳转
      if (props.data[i].link) {
        router.push(props.data[i].link);
      }
    };
    const onClickOutSide = e => {
      //console.log(e)
      if (e.target.classList.contains('menu-btn')) {
        return;
      }
      if (showMenu.value) {
        showMenu.value = false;
      }
    };
    return {
      subMenuIndex,
      showMenu,
      showSubMenu,
      onClick,
      changeLanguage,
      onClickOutSide
    };
  }
});